module.exports = __webpack_public_path__ + "static/media/46_A.dd7757cf.png";